<template>
  <v-container fluid class="no-padding-top">
    <v-row no-gutters>
      <v-col cols="12" class="limited-scrollable">
        <NewOrdersList
          v-if="$store.state.status[1]"
          :dataLoaded="dataLoaded"
          :orders="$store.state.orders[$store.state.status[1]]"
          :filterBy="'domicilio'" />
        <PreparingOrdersList
          v-if="$store.state.status[2]"
          :dataLoaded="dataLoaded"
          :orders="$store.state.orders[$store.state.status[2]]"
          :filterBy="'domicilio'" />
        <ReadyOrdersList
          v-if="$store.state.status[3]"
          :dataLoaded="dataLoaded"
          :orders="$store.state.orders[$store.state.status[3]]"
          :filterBy="'domicilio'" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import NewOrdersList from '../components/NewOrdersList';
  import PreparingOrdersList from '../components/PreparingOrdersList';
  import ReadyOrdersList from '../components/ReadyOrdersList';

  export default {
    name: 'Delivery',
    components: {
      NewOrdersList,
      PreparingOrdersList,
      ReadyOrdersList
    },
    data: () => ({
      dataLoaded: true,
    }),
    beforeMount() {},
    methods: {},
  }
</script>

<style scoped></style>